import { useLayoutEffect } from "react";
import { isMobile } from 'react-device-detect';
import routes from "./routes";

import { LineMgmProvider } from "./apps/@components";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { MantineProvider } from "@mantine/core";
import '@mantine/core/styles.css';
import '@mantine/carousel/styles.css';
import { isLiffFlow } from "./apps/liff/pages/campaign-wallpaper-page/wallpaperParams";

/**
 * 電腦版導向的 /desktop 網址。
 * 桌布活動國際版（/wallpaper/ 底下的頁，不含台灣 LIFF 入口 /wallpaper）
 * 帶上 campaign=wallpaper 與原本的 lang / country，讓 DesktopPage 顯示國際版文案。
 */
const getDesktopUrl = (pathname) => {
	const isWallpaperIntl = pathname.startsWith("/wallpaper/") && !isLiffFlow();
	if (!isWallpaperIntl) return "/desktop";

	const current = new URLSearchParams(window.location.search);
	const params = new URLSearchParams({ campaign: "wallpaper" });
	["lang", "country"].forEach((key) => {
		const value = current.get(key);
		if (value) params.set(key, value);
	});
	return `/desktop?${params.toString()}`;
};

function App() {
	// 禁止雙指縮放
	const preventMultiTouchZoom = () => {
		const preventMultiTouch = (event) => {
			if (event.touches.length >= 2) {
				event.preventDefault();
			}
		};

		// 添加事件監聽器
		document.addEventListener("touchstart", preventMultiTouch, {
			passive: false,
		});
		document.addEventListener("touchmove", preventMultiTouch, {
			passive: false,
		});
		document.addEventListener("touchend", preventMultiTouch, {
			passive: false,
		});

		// 返回一個清理函數來移除監聽器
		return () => {
			document.removeEventListener("touchstart", preventMultiTouch);
			document.removeEventListener("touchmove", preventMultiTouch);
			document.removeEventListener("touchend", preventMultiTouch);
		};
	};

	useLayoutEffect(() => {
		preventMultiTouchZoom();
    if (!isMobile) {
			const location = window.location.pathname;
			const ecLocation = location.includes("/ec");
			// PG 現場兌換頁可能用平板或筆電操作，不導去 /desktop
			const pgLocation = location.startsWith("/pg");
			if (location !== "/desktop" && !ecLocation && !pgLocation) {
				window.location.href = getDesktopUrl(location);
			}
    }
	}, []);

	return (
		<MantineProvider>
			<LineMgmProvider>
				<RouterProvider router={createBrowserRouter(routes)} />
			</LineMgmProvider>
		</MantineProvider>
	);
}

export default App;
